<template>
  <div>
    <el-card>
      <div slot="header" class="font-bold">用户管理</div>
      <el-form :inline="true" size="small">
        <el-form-item label="关键词">
          <el-input v-model="keyword" placeholder="搜索用户名" clearable @clear="fetch" @keyup.enter.native="fetch" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="status" placeholder="全部" clearable @change="fetch">
            <el-option label="正常" value="active" /><el-option label="已冻结" value="frozen" />
          </el-select>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="fetch">搜索</el-button></el-form-item>
      </el-form>
      <el-table :data="list" v-loading="loading" size="small">
        <el-table-column prop="username" label="用户名" width="150" />
        <el-table-column prop="status" label="状态" width="80">
          <template slot-scope="{row}">
            <el-tag :type="row.status==='active'?'success':'danger'" size="small">{{ row.status==='active'?'正常':'已冻结' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="VIP到期" width="160">
          <template slot-scope="{row}">{{ row.vipExpireAt ? formatDate(row.vipExpireAt) : '未开通' }}</template>
        </el-table-column>
        <el-table-column prop="createdAt" label="注册时间" width="160">
          <template slot-scope="{row}">{{ formatDate(row.createdAt) }}</template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <el-button :type="row.status==='active'?'danger':'success'" size="mini" @click="toggle(row)">
              {{ row.status === 'active' ? '冻结' : '解封' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top:16px;text-align:right" background layout="total,prev,pager,next"
        :total="total" :page-size="size" :current-page.sync="page" @current-change="fetch" />
    </el-card>
  </div>
</template>

<script>
import { adminApi } from '../api';

export default {
  data() {
    return { list: [], page: 1, size: 10, total: 0, loading: false, keyword: '', status: '' };
  },
  created() { this.fetch(); },
  methods: {
    async fetch() {
      this.loading = true;
      const res = await adminApi.listUsers({ page: this.page, size: this.size, keyword: this.keyword || undefined, status: this.status || undefined });
      this.list = res.data.list;
      this.total = res.data.total;
      this.loading = false;
    },
    async toggle(row) {
      const newStatus = row.status === 'active' ? 'frozen' : 'active';
      try {
        await this.$confirm('确定要' + (newStatus === 'frozen' ? '冻结' : '解封') + '该用户吗？', '确认');
        await adminApi.updateUserStatus(row.id, { status: newStatus });
        this.$message.success('操作成功');
        this.fetch();
      } catch (e) { /* canceled */ }
    },
    formatDate(d) {
      if (!d) return '';
      return new Date(d).toLocaleString('zh-CN');
    }
  }
};
</script>
